<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<h2>Fail Log - {{model.id}}</h2>
			</b-col>
			<b-col lg="6">
				<b-dropdown class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
							<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="changeLogStatus">Change Log Status to {{model.is_resolved ? 'Not Solved' : 'Solved'}}</b-dropdown-item>
					<b-dropdown-item v-bind:disabled=this.model.is_resolved @click="repostJsonData">Repost Json Data</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
		<b-card v-if="loadingData">
						<b-col cols="12" sm="12" md="12" lg="12">
							<p class="text-center">
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
							</p>
						</b-col>
		</b-card>
				<div v-else>
						<b-card>
				      	<b-row>
				      		<b-col>
										<b-form-group label="Error Message" label-for="logerror" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" plaintext v-show="true" id="logerror" v-model="model.error" type="text" :readonly="true"></b-form-input>
										</b-form-group>
							</b-col>
							<b-col>
										<b-form-group label="Resolution Status" label-for="logstatus" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" plaintext v-show="true" id="logstatus" v-bind:value="model.is_resolved ? 'Solved' : 'Not Solved'" type="text" :readonly="true"></b-form-input>
										</b-form-group>
				      		</b-col>
						</b-row>
						<b-row>
				      		<b-col>
									<b-form-group label="Requested Service" label-for="logservice" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" plaintext v-show="true" id="logservice" v-model="model.service" type="text" :readonly="true"></b-form-input>
									</b-form-group>
							</b-col>
							<b-col>
										<b-form-group label="Client Platform" label-for="logclient" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" plaintext v-show="true" id="logclient" v-model="model.client" type="text" :readonly="true"></b-form-input>
										</b-form-group>
							</b-col>
						</b-row>
						<b-row>
				      		<b-col>
									<b-form-group label="Generated At" label-for="logdate" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" plaintext v-show="true" id="logdate" v-model="model.generated_at" type="text" :readonly="true"></b-form-input>
									</b-form-group>
							</b-col>
							<b-col>
										<b-form-group label="Requested by User" label-for="loguser" :label-cols="4" horizontal>
											<b-form-input class="plaintext-input" plaintext v-show="true" id="loguser" v-model="model.user" type="text" :readonly="true"></b-form-input>
										</b-form-group>
							</b-col>
						</b-row>
						<b-row>
				      	<b-col>
										<b-form-group label="Traceback" label-for="logtraceback" :label-cols="2" horizontal>
											<pre v-show="true" id="logtraceback">{{ model.traceback }}</pre>
										</b-form-group>
							  </b-col>
						</b-row>
						<b-row>
				      		<b-col>
									<b-form-group label="Last Repost At" label-for="logrepostdate" :label-cols="4" horizontal>
										<b-form-input class="plaintext-input" plaintext v-show="true" id="logrepostdate" v-model="model.last_repost_at" type="text" :readonly="true"></b-form-input>
									</b-form-group>
							</b-col>
							<b-col>
										<b-form-group label="Last Repost Response" label-for="logrepostmessage" :label-cols="4" horizontal>

											<b-btn id="logrepostmessage" variant="primary" v-show=model.last_repost_response>{{model.last_repost_response ? model.last_repost_response.message : ''}}</b-btn>
                      <b-popover target="logrepostmessage" triggers="hover focus" v-if=model.last_repost_response>
                         <template slot="title"><strong>Last Repost Response</strong></template>
                         <strong>{{model.last_repost_response.status}}: </strong>
                         <span v-bind:class="model.last_repost_response.status === 'success' ? 'text-success' : 'text-danger'"><strong>{{model.last_repost_response.message}}</strong></span>
                         <div v-if=model.last_repost_response.traceback>
                          <pre>{{ model.last_repost_response.traceback }}</pre>
                         </div>
                      </b-popover>
										</b-form-group>
							</b-col>
						</b-row>
						</b-card>
						<b-card>
							<b-row>
				      		<b-col>
										<b-form-group label="Posted Json Data" label-for="logdata" :label-cols="2" horizontal>
											<!--b-form-textarea class="plaintext-input" plaintext v-show="true" v-model="json" id="logdata"  :rows="3" :max-rows="6" :readonly="true"></b-form-textarea-->
											<div class='textarea' id='logdata' v-html="this.json"/>
										</b-form-group>
							</b-col>
							</b-row>
						</b-card>
        		</div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import logs_service from './logs_service'

	export default {
		name: 'log',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getLogData()
		},
		data() {
			return {
				originalData: null,
				edit: false,
				loadingData: true,
				model: {
					id: null,
          			error: '',
          			service: '',
          			user: '',
          			client: '',
					generated_at: '',
					data: '',
					is_resolved: '',
					last_repost_at: '',
					last_repost_response: '',
					traceback: '',
					method: ''
				},
				json: ''
			}
		},
		mounted() {
			let jsonprettyScript = document.createElement('script')
			jsonprettyScript.setAttribute('src', 'static/dist/json_pretty.js')
			jsonprettyScript.setAttribute('async', 'false')
			jsonprettyScript.setAttribute('defer', 'false')
			document.head.insertBefore(jsonprettyScript, document.head.firstChild)
		},
		methods: {
			getLogData() {
				logs_service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.model = JSON.parse(JSON.stringify(data.log))
							//this.json =  JSON.stringify(data.log.data, undefined, 4)
							this.loadingData = false
							try
							  {  this.json = prettyPrint.default(data.log.data)}
							catch(e)
							  {this.json='<pre style="color: #FFFFFF">'+JSON.stringify(data.log.data, undefined, 4)+'</pre>'}

						}else {
							this.$swal(data.status, data.message, data.status)
							this.loadingData = false
							return
						}

					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			changeLogStatus(){
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to change this Log status to: " + (this.model.is_resolved ? 'Not Solved' : 'Solved') + "?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						logs_service.change_status(this.id,  this.model.is_resolved ? false : true)
							.then(data => {

								if (data[0] == 'success')
								{ this.$swal({type: data[0], title: data[0], text: data[1],  onBeforeOpen: this.getLogData}) }
								else
								{ this.$swal(data[0], data[1], data[0]) }
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			repostJsonData(){
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure you want to send the Data to service " + this.model.service + " with method " + this.model.method + "?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						logs_service.post_json_data(this.id,  this.model.data, this.model.service, this.model.method)
							.then(data => {

								if (data[0] == 'success')
								{ this.$swal({type: data[0], title: data[0], text: data[1], onBeforeOpen: this.getLogData}) }
								else
								{ this.$swal({type: data[0], title: data[0], text: data[1], onBeforeOpen: this.getLogData}) }
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			}
		}
	}
</script>
<style>
  .textarea {
  	width: 100%;
  	font-family: Menlo, Monaco, "Courier New", monospace;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    background-color: #24282A;
    color: #d4d4d4;
    text-align: left;
    border-top: 1px solid #121516;
    padding-top: 10px;
    padding-bottom: 10px;
	margin: 0;
	max-height: 350px;
	min-height: 200px;
	overflow: auto;
}

.json-pretty {
    padding-left: 30px;
    padding-right: 30px;
}
.json-selected {
    background-color: rgba(139, 191, 228, 0.19999999999999996);
}

.json-string {
    color: #cbd7df;
}

.json-key {
    color: #c8f71f;
}

.json-boolean {
    color: #5ccf52;
}

.json-number {
    color: #5ccf52;
}

.popover{
    max-width: 600px;
}
.popover-body{
    max-width: 600px;
}
.popover-header{
    max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/logs/log.vue